import React, { useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { useSelector, useDispatch } from 'react-redux';
import { hideSnackBarNotifications, hideError } from 'actions';

const NotificationToaster = () => {
  const dispatch = useDispatch();
  const commonState = useSelector(state => state.commonState);
  const session = useSelector(state => state.session);
  const { enqueueSnackbar } = useSnackbar();

  const isValidString = (value) => typeof value === 'string' && value.trim() !== '';

  useEffect(() => {
    if (isValidString(commonState.snackbar_notification)) {
      const options = {
        variant: commonState.snackbar_notification_type === 'success' ? 'success' : 'error',
        onClose: handleNotificationClose,
        autoHideDuration: 4000,
      };
      enqueueSnackbar(commonState.snackbar_notification, options);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [commonState.snackbar_notification]);

  useEffect(() => {
    if (isValidString(session.error)) {
      const options = {
        variant: session.error_type === 'message' ? 'success' : 'error',
        onClose: handleNotificationClose,
        autoHideDuration: 4000,
      };
      enqueueSnackbar(session.error, options);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session.error]);

  const handleNotificationClose = (event, reason) => {
    // Prevent hiding on clickaway (if desired)
    if (reason === 'clickaway') {
      return;
    }
    dispatch(hideSnackBarNotifications(commonState.snackbar_notification_type));
    dispatch(hideError());
  };

  return null; // No UI elements needed
};

export default NotificationToaster;
